import useSWR from "swr";

import { accountApi } from "@/apis/accounts/accountApi";
import { ConnectAccount, UserConnectChargeEnable } from "@/apis/clients";
import { useLoading } from "@/states/loading/operations";

export default function useGetPaymentSetting() {
  const withLoading = useLoading();

  const fetcher = async (): Promise<ConnectAccount> => {
    return new Promise((resolve, reject) => {
      withLoading(async () => {
        const result = await accountApi.getConnectedAccount();
        resolve(result.data);
      }).catch((error) => {
        reject(error);
      });
    });
  };

  const { data, error } = useSWR<ConnectAccount, Error>(
    "/connected-account",
    fetcher,
    {
      revalidateOnFocus: false,
    },
  );

  return {
    hasStripeAccount:
      data?.user_payment_setting?.charges_enabled ===
      UserConnectChargeEnable.ENABLED,
    connectedAccount: data,
    connectedAccountError: error,
    canPayment:
      data?.user_payment_setting?.charges_enabled ===
      UserConnectChargeEnable.ENABLED,
  };
}
